import dayjs from 'dayjs';
import cookie from 'js-cookie';

import {
  TOKEN,
  REFRESH_TOKEN,
  LAST_REFRESH_TIME,
  TOKEN_VALID_DAY,
} from '@/constants';

const cookieDomain = globalThis?.location?.href?.includes?.('.wukongedu.net')
  ? '.wukongedu.net'
  : '.wukongsch.com';

export const setToken = (token: string, refreshToken?: string) => {
  cookie.set(TOKEN, token);
  cookie.set(
    LAST_REFRESH_TIME,
    `${dayjs().add(TOKEN_VALID_DAY, 'day').unix()}`,
  );
  if (refreshToken) {
    cookie.set(REFRESH_TOKEN, refreshToken);
  }
};

export const removeToken = () => {
  try {
    cookie.remove(TOKEN);
    cookie.remove(TOKEN, {
      domain: cookieDomain,
      path: '/',
    });
  } catch (e) {
    console.error(e);
  }
};
